import * as React from 'react';
import { cn } from 'lib/utils';

export interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  /** A muted line under the value, e.g. "of 140 assigned". */
  sub?: React.ReactNode;
  /** A link under the value; takes the place of `sub`. */
  action?: React.ReactNode;
  /** Colours the value when it needs attention; otherwise it stays ink. */
  tone?: 'warning' | 'error';
  className?: string;
}

const VALUE_TONE = {
  warning: 'text-warning-700 dark:text-warning-400',
  error: 'text-error-700 dark:text-error-400',
} as const;

/** One figure on a bordered tile: label, big tabular value, then a quiet line or link. No icon tile. */
export function StatTile({ label, value, sub, action, tone, className }: StatTileProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5 rounded-lg border border-border bg-card px-4 py-3.5', className)}>
      <span className="truncate text-[12.5px] text-muted-foreground">{label}</span>
      <span
        className={cn(
          'text-2xl font-bold leading-[1.1] tracking-[-0.02em] tabular-nums text-foreground',
          tone && VALUE_TONE[tone],
        )}
      >
        {value}
      </span>
      {action ?? (sub != null && <span className="text-[12.5px] text-muted-foreground">{sub}</span>)}
    </div>
  );
}

export default StatTile;
